import { extractErrorMessage, extractStatus, httpClient } from '@/lib/api'
import { authTexts } from '../auth.texts'
import type {
  AuthApi,
  GetMeResult,
  LogoutResult,
  RequestCodeResult,
  VerifyOtpResult,
} from './auth-api.types'

export const prodAuthApi: AuthApi = {
  async requestCode(email: string): Promise<RequestCodeResult> {
    try {
      await httpClient.post('/api/partner/auth/email', { email })
      return { success: true }
    } catch (error: unknown) {
      return { success: false, error: extractErrorMessage(error, authTexts.login.serverError) }
    }
  },

  async verifyOtp(email: string, code: string): Promise<VerifyOtpResult> {
    try {
      const { data } = await httpClient.post('/api/partner/auth/verify-otp', { email, code })
      return { success: true, partner: data.partner }
    } catch (error: unknown) {
      const status = extractStatus(error)
      const message =
        status === 401
          ? extractErrorMessage(error, authTexts.otp.invalidCode)
          : extractErrorMessage(error, authTexts.otp.serverError)
      return { success: false, error: message }
    }
  },

  async resendCode(email: string): Promise<RequestCodeResult> {
    try {
      await httpClient.post('/api/partner/auth/resend-code', { email })
      return { success: true }
    } catch (error: unknown) {
      return { success: false, error: extractErrorMessage(error, authTexts.login.serverError) }
    }
  },

  async getMe(): Promise<GetMeResult> {
    try {
      const { data } = await httpClient.get('/api/partner/auth/me')
      return { success: true, partner: data.partner }
    } catch {
      return { success: false, error: 'Not authenticated' }
    }
  },

  async logout(): Promise<LogoutResult> {
    try {
      await httpClient.post('/api/partner/auth/logout')
      return { success: true }
    } catch (error: unknown) {
      return { success: false, error: extractErrorMessage(error, authTexts.logout.error) }
    }
  },
}
